export default "__VITE_ASSET__PR3aw49o__"